import {Component} from "../Component";
import {element} from "../CustomElement";
import {Page} from "../flipp-page/Page";
import {i18n} from "../../i18n/I18n";
import {AuthenticationService} from "../../services/AuthenticationService";
import {inject} from "../../services/di";
import {ConfigService} from "../../services/ConfigService";
import {Country, LocationService} from "../../services/LocationService";
import {AnalyticsService} from "../../services/AnalyticsService";
import {AccountsService} from "../../services/AccountsService";
import {AuthStatus} from "../../services/definitions/IAuthenticationService";
import {EventService} from "../../services/EventService";
import {LinkService} from "../../services/LinkService";
import {Dropdown} from "../flipp-dropdown/Dropdown";

@element("flipp-data-form")
export class CCPAForm extends Component<{}, void> {
	@inject auth: AuthenticationService;
	@inject config: ConfigService;
	@inject location: LocationService;
	@inject analytics: AnalyticsService;
	@inject fetchUserData: AccountsService;
	@inject eventService: EventService;
	@inject linkService: LinkService;

	refs: {
		formInputNameFirst: HTMLInputElement;
		formInputNameLast: HTMLInputElement;
		formInputEmail: HTMLInputElement;
		radioReceive: HTMLInputElement;
		radioDelete: HTMLInputElement;
		radioNotSell: HTMLInputElement;
		errorMsg0: HTMLElement;
		errorMsg1: HTMLElement;
		errorMsg2: HTMLElement;
		submitForm: HTMLFormElement;
		submitBtn: HTMLInputElement;
		modalWrapper: HTMLDivElement;
		modalDelete: HTMLDivElement;
		closeModalBtn: HTMLButtonElement;
		acceptDeleteBtn: HTMLButtonElement;
		modalError: HTMLDivElement;
		modalSignin: HTMLDivElement;
		errorTextField: HTMLElement;
		tooltipText: HTMLDivElement,
		dataFormWrapper: HTMLDivElement,
		spinner: HTMLElement
		canadaChipRef: HTMLElement
		usaChipRef: HTMLElement
		selectStateDropdownRef: Dropdown
	};

	state = {
		dataAction: "notSell",
		firstName: "",
		lastName: "",
		email: "",
		residentOf: "",
		access_token: "",
		user_id: "",
		sid: "",
		fsa: "",
		application_version: "",
		locale : "",
		country_code: "",
	};

	onAttach() {
		const form = this.refs.submitForm;
		const inputsNoSubmitBtn = 7;
		for (let i = 0; i < inputsNoSubmitBtn; i++) {
			form[i].addEventListener("change", this.handleChange);
		}
		this.refs.closeModalBtn.addEventListener("click", this.handleCloseModal);
		this.refs.acceptDeleteBtn.addEventListener("click", this.acceptDeleteData);
		window.addEventListener("redirect-from-form", this.changeUserLocation);
		window.addEventListener("flipp-auth", this.checkEmail);
		window.addEventListener("redirect-logout-form", this.changeUserLocation);
		this.state.dataAction = "";
		this.state.firstName = "";
		this.state.lastName = "";
		this.state.email = "";
		this.state.residentOf = "";
		this.checkSignIn();
		this.checkEmail();
		this.setSelectedCountry(this.getCountry());
	}

	setSelectedCountry(country: Country) {
		if (country === Country.USA) {
			this.refs.usaChipRef.classList.add("selected");
			this.refs.canadaChipRef.classList.remove("selected");
		} else if (country === Country.CANADA) {
			this.refs.usaChipRef.classList.remove("selected");
			this.refs.canadaChipRef.classList.add("selected");
		}
	}

	onDetach() {
		const form = this.refs.submitForm;
		const inputsNoSubmitBtn = 10;
		for (let i = 0; i < inputsNoSubmitBtn; i++) {
			form[i].removeEventListener("change", this.handleChange);
		}
		this.refs.closeModalBtn.removeEventListener("click", this.handleCloseModal);
		this.refs.acceptDeleteBtn.removeEventListener("click", this.acceptDeleteData);
		window.removeEventListener("redirect-from-form", this.changeUserLocation);
		window.removeEventListener("flipp-auth", this.checkEmail);
		window.removeEventListener("redirect-logout-form", this.changeUserLocation);
	}

	getSelectStateOptions(selectedCountry?: Country) {
		const detectedCountry = this.getCountry();
		const country = selectedCountry !== undefined ? selectedCountry : detectedCountry;
		const isFrench = this.location.locale === "fr-ca";
		const states = country === Country.CANADA ?
			[
				{name: isFrench ? "Québec" : "Quebec", value: "quebec"}
			] :
			[
				{name: isFrench ? "Californie" : "California", value: "california"},
				{name: "Colorado", value: "colorado"},
				{name: "Connecticut", value: "connecticut"},
				{name: "Virginia", value: "virginia"},
				{name: "Utah", value: "utah"},
			];
		return JSON.stringify(states);
	}

	render() {
		const privacyLink = this.location.locale === "fr-ca" ? "https://corp.flipp.com/legal/politique-de-confidentialite" : "https://corp.flipp.com/privacy";
		return <Page show="flyers">
			<section ref="spinner" class="main">
				<div class="loading">
					<div class="spinner"></div>
				</div>
			</section>
			<div ref="dataFormWrapper" class="data-form-wrapper">
				<h3>{i18n("my_data_title")}</h3>
				<div class="form-text">{i18n("my_data_text")}</div>
				<form
					name="dataForm"
					onSubmit={this.handleSubmit}
					class="form-inputs"
					ref="submitForm"
				>
					<input
						type="text"
						name="firstName"
						placeholder={i18n("my_data_name")}
						ref="formInputNameFirst"
						maxLength= {100}
					/>
					<p ref="errorMsg0" class="error-msg"></p>
					<input
						type="text"
						name="lastName"
						placeholder={i18n("my_data_surname")}
						ref="formInputNameLast"
						maxLength= {100}
					/>
					<p ref="errorMsg1" class="error-msg"></p>
					<input
						type="email"
						name="email"
						placeholder={i18n("my_data_email")}
						ref="formInputEmail"
						maxLength= {100}
						pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"
					/>
					<p ref="errorMsg2" class="error-msg"></p>

					<label>{i18n("my_data_select_country")}</label>
					<div class="select-country-wrapper">
						<div class="country" ref="canadaChipRef" onClick={() => this.handleCountryClick(Country.CANADA)}>Canada</div>
						<div class="country" ref="usaChipRef" onClick={() => this.handleCountryClick(Country.USA)}>USA</div>
					</div>

					<label>{i18n("my_data_select_state")}</label>
					<div class="select-state-wrapper">
						<Dropdown ref="selectStateDropdownRef" options={this.getSelectStateOptions()} handleItemSelected={this.handleItemSelected.bind(this)}/>
					</div>
					<div class="horizontal-divider"></div>
					<label>{i18n("my_data_select_request")}</label>
					<div class="radio-group">
						<div class="radio-option">
							<input
								type="radio"
								id="notSell"
								name="dataAction"
								value="notSell"
								ref="radioNotSell"
							/>
							<label for="notSell">{i18n("my_data_select_option_label_do_not_sell")}
								<div class="radio-text">{i18n("my_data_select_option_text_do_not_sell")}</div>
							</label>
						</div>
						<div class="radio-option">
							<input
								type="radio"
								id="receive"
								name="dataAction"
								value="receive"
								ref="radioReceive"
							/>
							<label for="receive">{i18n("my_data_select_option_label_receive_copy")}
								<div class="radio-text">{i18n("my_data_select_option_text_receive_copy")}</div>
							</label>
						</div>
						<div class="radio-option">
							<input
								type="radio"
								id="delete"
								name="dataAction"
								value="delete"
								ref="radioDelete"
							/>
							<label for="delete">{i18n("my_data_select_option_label_delete_data")}
								<div class="radio-text">{i18n("my_data_select_option_text_delete_data")}</div>
							</label>
						</div>
					</div>

					<div class="disclaimer-text">
						<p>{i18n("my_data_disclaimer_text1")} <a href={privacyLink} target="_blank">{privacyLink}</a>.</p>
						<p>{i18n("my_data_disclaimer_text2")}</p>
						<p>{i18n("my_data_disclaimer_text3")}</p>
						</div>
					<input
						class="submit"
						type="submit"
						value={i18n("submit")}
						ref="submitBtn"
						disabled
					/>
				</form>
			</div>
			<div ref="modalWrapper" class="modal-wrapper">
			</div>
			<div ref="modalDelete" class="modal-delete">
				<h1>{i18n("my_data_delete_modal_title")}</h1>
				<p>{i18n("my_data_delete_modal_text")}</p>
				<div class="modalBtnWrapper">
					<button class="closeModalBtn" ref="closeModalBtn">{i18n("cancel")}</button>
					<button class="acceptModalBtn" ref="acceptDeleteBtn">{i18n("my_data_delete_modal_confirm")}</button>
				</div>
			</div>
			<div ref="modalError" class="modal-delete">
				<h1><span>{i18n("my_data_error_modal_title")}</span></h1>
				<p ref="errorTextField"></p>
				<div class="modalBtnWrapper">
					<button onClick={this.handleCloseModal} class="closeModalBtn">{i18n("ok")}</button>
				</div>
			</div>
			<div ref="modalSignin" class="modal-delete">
				<h1><span>{i18n("my_data_error_modal_title")}</span></h1>
				<p>{i18n("my_data_error_modal_text")}</p>
				<div class="modalBtnWrapper">
					<button onClick={this.handleSignin} class="closeModalBtn">{i18n("signin")}</button>
				</div>
			</div>
		</Page>;
	}

	private handleSubmit = (e: any) => {
		e.preventDefault();
		const form = this.refs.submitForm;
		const textInputs = 3;
		let inputsFilled = [];
		for (let i = 0; i < textInputs; i++) {
			if (form[i	].value.length === 0) {
				form[i].style.borderColor = "red";
				if (form[0].value.length === 0 && form[1].value.length === 0 && form[2].value.length === 0) {
					this.refs.errorMsg0.textContent = i18n("my_data_name_error");
					this.refs.errorMsg1.textContent = i18n("my_data_surname_error");
					this.refs.errorMsg2.textContent = i18n("my_data_email_error");
				} else if (form[0].value.length === 0 && form[1].value.length === 0) {
					this.refs.errorMsg0.textContent = i18n("my_data_name_error");
					this.refs.errorMsg1.textContent = i18n("my_data_surname_error");
				} else if (form[1].value.length === 0 && form[2].value.length === 0) {
					this.refs.errorMsg1.textContent = i18n("my_data_surname_error");
					this.refs.errorMsg2.textContent = i18n("my_data_email_error");
				} else if (form[0].value.length === 0) {
					this.refs.errorMsg0.textContent = i18n("my_data_name_error");
				} else if (form[1].value.length === 0) {
					this.refs.errorMsg1.textContent = i18n("my_data_surname_error");
				} else if (form[2].value.length === 0) {
					this.refs.errorMsg2.textContent = i18n("my_data_email_error");
				}
			} else {
				inputsFilled.push("check");
				form[i].style.borderColor = "grey";
			}
		}
		if (inputsFilled.length === textInputs && this.state.dataAction === "receive") {
			this.receiveCopyData();
		} else if (inputsFilled.length === textInputs && this.state.dataAction === "delete") {
			this.refs.modalWrapper.classList.add("showed");
			this.refs.modalDelete.classList.add("showed");
		} else if (inputsFilled.length === textInputs && this.state.dataAction === "notSell") {
			this.notSellData();
		}
	}

	private handleChange = (e: any) => {
		Object.assign(this.state, {[e.target.name]: e.target.value});
		if (e.target.name !== "dataAction" && e.target.name !== "residentOf") {
			e.target.style.borderColor = "grey";
			this.refs.errorMsg0.textContent = "";
			this.refs.errorMsg1.textContent = "";
			this.refs.errorMsg2.textContent = "";
		}
		if (this.state.dataAction && this.state.residentOf) {
			this.refs.submitBtn.classList.add("active");
			this.refs.submitBtn.removeAttribute("disabled");
		} else {
			this.refs.submitBtn.classList.remove("active");
			this.refs.submitBtn.setAttribute("disabled", "disabled");
		}
	}

	private handleCountryClick(country: Country) {
		this.setSelectedCountry(country);
		const options = this.getSelectStateOptions(country);
		this.refs.selectStateDropdownRef.setAttribute("options", options);
		this.handleChange({target: {name: "residentOf", value: ""}});
	}

	private handleItemSelected(value: string) {
		this.state.residentOf = value;
		this.handleChange({target: {name: "residentOf", value}});
	}

	private handleCloseModal = (e: any) => {
		e.preventDefault();
		this.refs.modalWrapper.classList.remove("showed");
		this.refs.modalDelete.classList.remove("showed");
		this.refs.modalError.classList.remove("showed");
	}

	private handleSignin = (e: any) => {
		e.preventDefault();
		const linkService = LinkService.getInstance();
		linkService.execute("/signin", this);
	}

	private acceptDeleteData = async (e: any) => {
		e.preventDefault();
		this.refs.modalWrapper.classList.remove("showed");
		this.refs.modalDelete.classList.remove("showed");
		this.refs.radioDelete.checked = true;
		this.state.dataAction = "delete";
		this.refs.spinner.classList.add("not-hide");
		this.refs.dataFormWrapper.classList.add("transparent");
		try {
			await this.fetchUserData.deleteUserData(this.state);
			this.refs.spinner.classList.remove("not-hide");
			this.refs.dataFormWrapper.classList.remove("transparent");
			this.linkService.execute("/data/success", this);
		}	catch (e) {
			this.handleSubmitError(e);
			}
	}

	private receiveCopyData = async () => {
		this.refs.spinner.classList.add("not-hide");
		this.refs.dataFormWrapper.classList.add("transparent");
		try {
			await this.fetchUserData.receiveCopyData(this.state);
			this.refs.spinner.classList.remove("not-hide");
			this.refs.dataFormWrapper.classList.remove("transparent");
			this.linkService.execute("/data/success", this);
		} catch (e) {
			this.handleSubmitError(e);
			}
	}

	private notSellData = async () => {
		this.refs.spinner.classList.add("not-hide");
		this.refs.dataFormWrapper.classList.add("transparent");
		try {
			await this.fetchUserData.notSellData(this.state);
			this.refs.spinner.classList.remove("not-hide");
			this.refs.dataFormWrapper.classList.remove("transparent");
			this.linkService.execute("/data/success", this);
		} catch (e) {
			this.handleSubmitError(e);
			}
	}

	private handleUnauthorizedUser = () => {
		this.refs.modalWrapper.classList.add("showed");
		this.refs.modalSignin.classList.add("showed");
		this.refs.spinner.classList.remove("not-hide");
		this.refs.dataFormWrapper.classList.remove("transparent");
	}

	private handleSubmitError = (error: any) => {
		this.refs.errorTextField.textContent = error.message;
		this.refs.modalWrapper.classList.add("showed");
		this.refs.modalError.classList.add("showed");
		this.refs.spinner.classList.remove("not-hide");
		this.refs.dataFormWrapper.classList.remove("transparent");
	}

	private checkEmail = () => {
		if (this.auth.status === AuthStatus.LOGGED_IN && this.auth.user.info.email) {
			const loginUserEmail = `${this.auth.user.info.email}`;
			this.refs.formInputEmail.value = loginUserEmail;
			this.state.email = loginUserEmail;
			this.refs.formInputEmail.setAttribute("disabled", "disabled");
		}
		this.getToken();
	}

	private getToken = () => {
		if (this.auth.status === AuthStatus.LOGGED_IN) {
			window.removeEventListener("redirect-from-form", this.changeUserLocation);
			const appVersionArray = this.config.BUILD.split("/");
			const countryCodeArray = this.location.locale.split("-");
			this.state.application_version = appVersionArray[appVersionArray.length - 1];
			this.state.sid = this.analytics.sessionId;
			this.state.fsa = this.location.postalCode;
			this.state.locale = this.location.locale;
			this.state.country_code = countryCodeArray[countryCodeArray.length - 1].toUpperCase();
			this.state.user_id = this.auth.user.token["user_id"];
			this.state.access_token = this.auth.user.token["access_token"];
		}
	}

	private changeUserLocation = () => {
		this.linkService.execute("/flyers", this);
	}

	private checkSignIn = () => {
		if (this.auth.status !== AuthStatus.LOGGED_IN) {
			this.handleUnauthorizedUser();
		}
	}

	private getCountry() {
		const info = this.location.getStoredInfo();
		if (info.country_code_by_ip === "CA") {
			return Country.CANADA;
		} else if (info.country_code_by_ip === "US") {
			return Country.USA;
		} else if (info.country_code_by_postal_code === "US") {
			return Country.USA;
		} else {
			return Country.CANADA;
		}
	}

}
